import mstore from '@/store/meeting-store'

export default {
  async logoff_kyoutu () {
    let meetingSession = mstore.getters.meetingSession
    let myselfVideoElm
    if (meetingSession !== null) {
      if (JSON.parse(localStorage.isOnlineMeeting) === true) {
        if (sessionStorage.customerType === 'guest') {
          myselfVideoElm = document.getElementById('guest1')
        } else {
          myselfVideoElm = document.getElementById('myself')
        }
        console.log('meetingSession:', meetingSession)
        console.log('audioVideo:', meetingSession.audioVideo)
        console.log('startVideoInput:', meetingSession.audioVideo?.startVideoInput)
        await meetingSession.audioVideo.stopVideoInput()
        // meetingSession.audioVideo.chooseVideoInputDevice(null)
        meetingSession.audioVideo.stopLocalVideoTile()
        meetingSession.audioVideo.stopVideoPreviewForVideoInput(myselfVideoElm)
      }
      meetingSession.audioVideo.stopContentShare()
      meetingSession.audioVideo.stop()
      mstore.commit('setMeetingSession', null)
      mstore.commit('setMyselfVideo', null)
      mstore.commit('setYourselfVideo', null)
      mstore.commit('setGuest1selfVideo', null)
      mstore.commit('setGuest2selfVideo', null)
      mstore.commit('setGuest3selfVideo', null)
      return true
    }
    return false
  }
}
